module.exports = __webpack_public_path__ + "static/media/visa.9ea78eb8.svg";